import React from 'react';
import { Content } from './Content';
import { DataExtractionProvider } from '@/context/DataExtraction';

export function DataExtraction() {
	return (
		<DataExtractionProvider>
			<Content />
		</DataExtractionProvider>
	);
}
